import { render } from "./AddLabUserAccount.vue?vue&type=template&id=1bfb622c&scoped=true"
import script from "./AddLabUserAccount.vue?vue&type=script&lang=js"
export * from "./AddLabUserAccount.vue?vue&type=script&lang=js"

import "./AddLabUserAccount.vue?vue&type=style&index=0&id=1bfb622c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bfb622c"],['__file',"src/views/topdog/labs/userAccounts/users/AddLabUserAccount.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bfb622c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bfb622c', __exports__)) {
    console.log('reload')
    api.reload('1bfb622c', __exports__)
  }
  
  module.hot.accept("./AddLabUserAccount.vue?vue&type=template&id=1bfb622c&scoped=true", () => {
    console.log('re-render')
    api.rerender('1bfb622c', render)
  })

}


export default __exports__